import {VetClinic, VetDoctor} from "./vet-clinic.model";
import {PartnerProduct} from "./partner-product.model";
import {User} from "./user.model";
import {Partner} from "./partner.model";

/**
 * Model reprezentujący Rekomendację Produktową.
 * Tworzona przez lekarza weterynarii podczas lub po wizycie, by ułatwić pacjentowi
 * zakup odpowiednich produktów w zintegrowanym sklepie (E-commerce).
 */
export class ProductRecommendation {

  /** Globalnie unikalny identyfikator rekomendacji. */
  public uuid: string;

  /** Data i czas wystawienia rekomendacji przez lekarza. */
  public created: Date;

  /** ID partnera biznesowego, którego produkty są polecane. */
  public partnerId: number;
  public partner: Partner;

  /** Obiekt kliniki, w której wystawiono rekomendację. */
  public vetClinic: VetClinic;

  /** ID klienta B2B, do której należy klinika. */
  public vClientId: number;

  /** Lista konkretnych produktów zaleconych pacjentowi. */
  public products: PartnerProduct[];

  public pargmaticBoxCode: string;

  /** Użytkownik (właściciel zwierzęcia), który otrzymuje tę rekomendację w aplikacji. */
  public user: User;
  public userUUID: string;

  /** Lekarz weterynarii, który jest autorem tej rekomendacji. */
  public vetDoctorUUID: string;
  public vetDoctor: VetDoctor;

  /** Data usunięcia. */
  public deleted: Date;

}
